export default {"src":"/_next/static/media/gcf_01.37253857.svg","height":80,"width":346,"blurWidth":0,"blurHeight":0};